module.exports = __webpack_public_path__ + "img/speisekarte_px.a140f5be.png";